export const ResetSelectedItems = () => {
    let event = new CustomEvent('reset-selected-items');
    window.dispatchEvent(event);
}